import { FC, Suspense, lazy, useState } from 'react';
import OutsideClickHandle from 'components/outside-click-handler/OutsideClickHandler';
import { SmileIcon } from 'assets/icons';
import type { EmojiClickData } from 'emoji-picker-react';
import './styles.css';

const EmojiSelector = lazy(() => import('./EmojiSelector'));

interface IconPickerProps {
  selectedIcon: string;
  onChange: (icon: string) => void;
  label?: string;
  emojiPickerClassName?: string;
  alignRight?: boolean;
}

const IconPicker: FC<IconPickerProps> = ({
  selectedIcon,
  onChange,
  label,
  emojiPickerClassName,
  alignRight = false
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleIconSelect = (emoji: EmojiClickData) => {
    onChange(emoji.emoji);
    setIsOpen(false);
  };

  const handleRemoveIcon = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    onChange('');
  };

  const handleAddIcon = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="flex flex-col gap-2">
      {label && (
        <div className="text-17px font-semibold leading-[18px] tracking-[-0.3px] text-headingGray">{label}</div>
      )}
      <div className="flex items-center gap-3">
        <OutsideClickHandle onOutsideClick={() => setIsOpen(false)}>
          <div className="relative">
            <div className="flex items-center gap-2">
              <button
                className="flex h-[50px] items-center gap-2 
              rounded bg-secondaryBtn px-4 text-[15px] font-semibold text-heading"
                onClick={handleAddIcon}>
                {selectedIcon ? (
                  <span className="text-xl">{selectedIcon}</span>
                ) : (
                  <>
                    <SmileIcon className="h-5 w-5 text-secondary" />
                  </>
                )}
              </button>
              {selectedIcon ? (
                <button onClick={handleRemoveIcon} className="cursor-pointer text-17px font-semibold text-error">
                  Remove icon
                </button>
              ) : (
                <span className="cursor-pointer text-17px font-semibold text-secondary" onClick={handleAddIcon}>
                  +Add icon
                </span>
              )}
            </div>

            {isOpen && (
              <div
                className={`absolute z-50 mt-1 rounded-md ${
                  alignRight ? 'left-full -bottom-3/4 ml-2' : 'left-0 top-full mb-2'
                } ${emojiPickerClassName}`}>
                <Suspense fallback={null}>
                  <EmojiSelector onSelect={handleIconSelect} />
                </Suspense>
              </div>
            )}
          </div>
        </OutsideClickHandle>
      </div>
    </div>
  );
};

export default IconPicker;
